var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form-v6';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { InputAdornment, TextField } from '@mui/material';
import { LocalizationProvider, MobileTimePicker, } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
import { helperText } from '../../utils/reactHookFormUtils';
export const ErrorLabel = styled.p `
  color: ${theme.palette.error.main};
  font-size: 0.75rem;
  margin: 0;
`;
export const TimeInput = (props) => {
    const required = props.isRequired ? '*' : '';
    const timeValidation = (value) => {
        if (!value)
            return;
        if (!moment(value, 'HH:mm', true).isValid())
            return 'Invalid time';
    };
    return (_jsxs("div", { children: [_jsx(Controller, { rules: {
                    required: props.isRequired ? 'This field is required' : undefined,
                    validate: timeValidation,
                }, valueName: "value", control: props.control, name: props.name, defaultValue: null, render: ({ onChange, value, name, onBlur }) => (_jsx(LocalizationProvider, Object.assign({ dateAdapter: AdapterMoment, localeText: Object.assign({ clearButtonLabel: 'CLEAR' }, props.localeText) }, { children: _jsx(MobileTimePicker, { label: `${props.label}${required}`, onChange: (date) => {
                            onChange(date);
                        }, ampm: false, value: value, disabled: props.disabled, views: ['hours', 'minutes'], componentsProps: {
                            actionBar: {
                                actions: ['clear', 'accept', 'cancel'],
                            },
                        }, DialogProps: {
                            sx: {
                                'span.PrivatePickersToolbarText-root': {
                                    fontSize: '40px',
                                },
                                '.MuiTimePickerToolbar-hourMinuteLabel': {
                                    alignItems: 'center',
                                },
                                '.MuiPickersToolbar-content': {
                                    justifyContent: 'center',
                                },
                                '.MuiPickersToolbar-penIconButton': { display: 'none' },
                                '.MuiDialogActions-root > .MuiButton-text:first-child': {
                                    marginRight: 'auto',
                                },
                            },
                        }, toolbarTitle: props.label, renderInput: (_a) => {
                            var { inputProps } = _a, params = __rest(_a, ["inputProps"]);
                            return (_jsx(TextField, Object.assign({}, params, { sx: {
                                    'input::placeholder': {
                                        textTransform: 'capitalize',
                                    },
                                }, InputProps: {
                                    endAdornment: (_jsx(InputAdornment, Object.assign({ position: "start" }, { children: _jsx(AccessTimeIcon, { fontSize: "small" }) }))),
                                }, error: false, autoFocus: props.autoFocus, inputProps: Object.assign(Object.assign({}, inputProps), { name: name, 'data-testid': props['data-testid'] }), onBlur: (_) => {
                                    onBlur();
                                }, margin: "dense", helperText: props.helperText, fullWidth: true, autoComplete: "off", name: props.name })));
                        } }) }))) }), props.errors && (_jsx(ErrorLabel, { children: props.errorMessage || helperText(props.name, props.errors) }))] }));
};
